import React, { Component } from 'react';
import { HashRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { YMInitializer } from 'react-yandex-metrika';
import ReactGA from 'react-ga';

import './App.css';
import Home from './pages/home'
import Card from './pages/card'
import Response from './pages/response'
import End from './pages/end'
import Header from './components/header'
import Footer from './components/footer'
import { getParameterByName } from "./helpers";

ReactGA.initialize('UA-88014128-25');
ReactGA.pageview(window.location.pathname + window.location.search);


class App extends Component {
  state = {
    token: null,
  }

  componentDidMount() {
    let token = getParameterByName('token', window.location.href)
    sessionStorage.setItem('token', token)
    this.setState({token})
  }

  render() {
    const { token } = this.state
    return (
      <div className="App">
        <YMInitializer accounts={[42193809]} />

        <Router>
          <div>
            <Header/>
            <Switch>
              <Route path="/end" render={() => <End/>}  />
              <Route path="/card" render={() => <Card/>} />
              <Route path="/response" render={() => <Response/>} />
              <Route path="/" render={() => (token ? ( <Redirect to={`/card/?token=${token}`} />) : (<Home/>))} exact />
            </Switch>
            <Footer />
          </div>
        </Router>
      </div>
    );
  }
}

export default App;
